<template>
  <DpaNewsBaseModal
    ref="modal"
    test-id="termsOfServiceModal"
    :submit-button-label="t('control.goToNext')"
    :submit-disabled="!agreedToTos"
    :is-loading="isLoading"
    @submit="handleAgreeToTos"
    @close="handleClose">
    <div class="mx-2 mt-4 mb-2 flex flex-col items-center gap-y-6">
      <DpaNewsIcon class="size-12" />
      <h1 class="text-center text-2xl/tight font-medium text-neutral-primary">
        {{ t("termsOfService.title") }}
      </h1>
      <i18n-t
        keypath="termsOfService.explanation"
        tag="p"
        class="text-base text-neutral-subtle">
        <template #link>
          <RouterLink
            class="font-semibold text-primary"
            :to="{ name: 'privacy' }">
            {{ t("termsOfService.here") }}.
          </RouterLink>
        </template>
      </i18n-t>
      <div class="inline-flex items-center gap-x-2 self-start text-base">
        <UiCheckbox
          data-testid="termsOfServiceCheckbox"
          :checked="agreedToTos"
          @change="agreedToTos = !agreedToTos">
          <div>
            <i18n-t keypath="termsOfService.agreeToTos" tag="p">
              <template #linkToTos>
                <RouterLink
                  class="font-semibold text-primary"
                  :to="{ name: 'termsOfUse' }">
                  {{ t("termsOfService.tos") }}
                </RouterLink>
              </template>
            </i18n-t>
          </div>
        </UiCheckbox>
      </div>
    </div>
  </DpaNewsBaseModal>
</template>

<script setup lang="ts">
import UiCheckbox from "@dpa-id-components/dpa-shared-components/src/components/UiCheckbox/UiCheckbox.vue";
import { onMounted, ref, useTemplateRef } from "vue";
import { useI18n } from "vue-i18n";

import DpaNewsIcon from "@/assets/vectors/dpa-news-icon.svg";

import DpaNewsBaseModal from "../DpaNewsBaseModal/DpaNewsBaseModal.vue";

const { t } = useI18n();

const modal = useTemplateRef<InstanceType<typeof DpaNewsBaseModal>>("modal");

const isLoading = ref(false);
const agreedToTos = ref(false);
const userSubmitted = ref(false);

const emit = defineEmits<{
  abort: [];
  submit: [];
}>();

const handleAgreeToTos = () => {
  if (!agreedToTos.value) {
    return;
  }
  isLoading.value = true;
  userSubmitted.value = true;
  emit("submit");
};

const handleClose = () => {
  if (!userSubmitted.value) {
    emit("abort");
  }
};

onMounted(() => {
  modal.value?.showModal();
});
</script>
